<template>
  <div
    class="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100"
  >
    <div
      class="max-w-4xl mx-auto flex items-start justify-center px-6 pt-8 md:pt-12"
    >
      <div class="w-full text-center mt-10">
        <div
          class="inline-flex items-center justify-center mb-6 w-20 h-20 rounded-2xl bg-white/80 shadow-lg backdrop-blur"
        >
          <!-- Simple house/door logo -->
          <!-- <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            class="w-10 h-10 text-indigo-600"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M3 10.5 12 3l9 7.5"
            />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M5 9.75V20a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9.75"
            />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M10 21v-6a2 2 0 0 1 2-2v0a2 2 0 0 1 2 2v6"
            />
          </svg> -->

          <img
            src="@/assets/logo.jpg"
            alt="Company Logo"
            class="w-full h-full object-cover rounded-xl"
          />
        </div>

        <h1
          class="text-3xl md:text-4xl font-semibold text-slate-800 tracking-tight"
        >
          ያለ ደላላ ሽያጭ
        </h1>
        <p class="mt-2 text-slate-600">ሻጭ እና ገዢ በቀጥታ ይገናኙ!</p>

        <div class="mt-8 flex items-center justify-center gap-3 text-slate-600">
          <span class="sr-only">Loading</span>
          <span class="loader" aria-hidden="true"></span>
          <span class="text-sm">Initializing...</span>
        </div>

        <div v-if="userName" class="mt-4 text-xs text-slate-500">
          Welcome, {{ userName }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apolloClient } from "@/apollo"; // your Apollo client instance
import { gql } from "@apollo/client/core";
import { toast } from "@/toast";

export default {
  data() {
    return {
      userName: "",
      isVerified: false,
    };
  },

  methods: {
    async registerTelegramUser(telegramUser) {
      this.isVerified = false;

      // Accepts Telegram user object and ensures user exists in backend
      const REGISTER_OR_GET_USER = gql`
        mutation RegisterOrGetUser(
          $user_id: String!
          $username: String
          $kebele_id: String
        ) {
          registerOrGetUser(
            user_id: $user_id
            username: $username
            kebele_id: $kebele_id
          ) {
            id
            user_id
            username
            kebele_id
            created_at
          }
        }
      `;

      const variables = {
        user_id: telegramUser.id?.toString() || "",
        username: telegramUser.username || null,
        kebele_id: null, // Unknown at splash; can be updated later in profile
      };

      try {
        const result = await apolloClient.mutate({
          mutation: REGISTER_OR_GET_USER,
          variables,
          errorPolicy: "all",
        });

        const registered = result?.data?.registerOrGetUser;
        if (registered?.id) {
          // Optionally store backend user id if your store supports it
          if (this.$store?.dispatch) {
            try {
              this.$store.dispatch("setBackendUserId", registered.id);
            } catch (_) {
              return;
            }
          }
          toast.success("Logged in successfully!");
          this.isVerified = true;
        } else {
          toast.info("Continuing as Telegram user");
        }
      } catch (e) {
        this.isVerified = false;
        // Non-blocking: allow navigation even if registration fails
        console.error("User registration failed:", e);
        toast.warning("Could not verify user now. Retrying later.");
      }
    },
    async addReferralRecord(senderTgId, receiverTgId) {
      const senderId = String(senderTgId || "").trim();
      const receiverId = String(receiverTgId || "").trim();

      if (!senderId || !receiverId || senderId === receiverId) {
        return;
      }

      const ADD_REFERRAL = gql`
        mutation AddReferral($sender_tg_id: String!, $receiver_tg_id: String!) {
          addReferral(
            sender_tg_id: $sender_tg_id
            receiver_tg_id: $receiver_tg_id
          ) {
            id
            sender_tg_id
            receiver_tg_id
            is_confirmed
          }
        }
      `;

      try {
        await apolloClient.mutate({
          mutation: ADD_REFERRAL,
          variables: {
            sender_tg_id: senderId,
            receiver_tg_id: receiverId,
          },
          errorPolicy: "all",
        });
      } catch (e) {
        console.error("Referral registration failed:", e);
      }
    },
    goHome(name) {
      this.$router
        .push({
          name: name,
        })
        .catch(() => {
          return;
        });
    },
    goToChannel() {
      window.location.href = "https://t.me/yaledelala";
    },

    async getUser() {
      if (
        window.Telegram &&
        window.Telegram.WebApp &&
        window.Telegram.WebApp.initDataUnsafe?.user
      ) {
        await window.Telegram.WebApp.ready();

        const user = await window.Telegram.WebApp.initDataUnsafe.user;

        let param1 = await window.Telegram.WebApp.initDataUnsafe.start_param;
        // param1 = params.get("postId");
        // this.tg_id = user.id.toString();
        // this.tg_username = user.username || "No Username";
        this.$store.dispatch("setUserId", user.id.toString());
        this.userName = user.username || "No Username";

        // Ensure user exists in backend (register if not)
        await this.registerTelegramUser(user);
        if (!this.isVerified) {
          return;
        }

        await window.Telegram.WebApp.expand();

        if (param1 != null && param1 != "null" && param1 != "") {
          if (param1.startsWith("rental_id")) {
            const id = parseInt(param1.split("_id")[1].toString());

            this.$router
              .push({
                name: "singleRental",
                params: { id },
              })
              .catch(() => {
                return;
              });
          } else if (param1.startsWith("rental_view")) {
            this.goHome("admin");
          } else if (param1.startsWith("my_rental_view")) {
            this.goHome("myrental");
          } else if (param1.startsWith("ref_")) {
            const senderTgId = param1.split("ref_")[1];
            await this.addReferralRecord(senderTgId, user.id.toString());
            this.goToChannel();
          } else {
            this.goHome("home");
          }
        } else {
          this.goHome("home");
        }

        // this.goHome("home");

        // await window.Telegram.WebApp.enableClosingConfirmation();
        // await window.Telegram.WebApp.disableVerticalSwipes();
        // await window.Telegram.WebApp.setHeaderColor("#000000");
        // await window.Telegram.WebApp.setBottomBarColor("#000000");
        // await this.login();
      } else {
        // this.$store.dispatch("setUserId", "6160879304");
        // this.goHome("home");
      }
    },
  },

  async created() {
    this.$store.dispatch("setUserId", "");
    await this.getUser();
  },
};
</script>

<style scoped>
/* Splash screen subtle fade-in */
.fade-in {
  animation: fadeIn 600ms ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Accessible minimal loader */
.loader {
  width: 18px;
  height: 18px;
  border-radius: 9999px;
  border: 3px solid rgba(254, 87, 34, 0.25); /* indigo-600/25 */
  border-top-color: rgba(254, 87, 34); /* indigo-600 */
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
